/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  footerContactUs: {
    id: 'Footer_ContactUs',
    defaultMessage: 'Contact us',
  },
  footerAboutUs: {
    id: 'Footer_AboutUs',
    defaultMessage: 'About us',
  },
  footerEmergencyAssistance: {
    id: 'Footer_EmergencyAssistance',
    defaultMessage: 'Emergency assistance',
  },
  footerOfficePATHS: {
    id: 'Footer_OfficePATHS',
    defaultMessage: 'Office PATHS',
  },
  footerSecurity: {
    id: 'Footer_Security',
    defaultMessage: 'Security',
  },
  footerPrivacy: {
    id: 'Footer_Privacy',
    defaultMessage: 'Privacy',
  },
  footerAccessibility: {
    id: 'Footer_Accessibility',
    defaultMessage: 'Accessibility',
  },
  footerDisclaimer: {
    id: 'Footer_Disclaimer',
    defaultMessage: 'Disclaimer',
  },
  footerFAQ: {
    id: 'Footer_FAQ',
    defaultMessage: 'FAQ',
  },
  footerNavigation: {
    id: 'Footer_Navigation',
    defaultMessage: 'Footer navigation',
  },
});
